module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "internal-application-amend"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "Amendment Request",
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "amendForm"
    }
  }, [_c('alert', {
    attrs: {
      "show": _vm.showError,
      "type": "danger"
    },
    on: {
      "update:show": function($event) {
        _vm.showError = $event
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorString))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Request Amendment for the application")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Select licensed activities to amend")]), _vm._v(" "), _vm._l((_vm.amendableActivities), function(activity) {
    return _c('div', [_c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.amendment.activity_list),
        expression: "amendment.activity_list"
      }],
      attrs: {
        "type": "checkbox",
        "name": activity.name,
        "id": activity.id
      },
      domProps: {
        "value": activity.id,
        "checked": Array.isArray(_vm.amendment.activity_list) ? _vm._i(_vm.amendment.activity_list, activity.id) > -1 : (_vm.amendment.activity_list)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.amendment.activity_list,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = activity.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.amendment, "activity_list", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.amendment, "activity_list", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.amendment, "activity_list", $$c)
          }
        }
      }
    }), _vm._v(_vm._s(activity.name) + "\n                                        ")])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Reason")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amendment.reason),
      expression: "amendment.reason"
    }],
    ref: "reason",
    staticClass: "form-control",
    attrs: {
      "name": "reason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.amendment, "reason", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.reason_choices), function(item) {
    return _c('option', {
      domProps: {
        "value": item.key
      }
    }, [_vm._v(_vm._s(item.value))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Additional Comments to User")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amendment.text),
      expression: "amendment.text"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name"
    },
    domProps: {
      "value": (_vm.amendment.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.amendment, "text", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.amendment.text))])])])])])], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5110136"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/applications/amendment_request.vue
// module id = 1066
// module chunks = 0